//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Typography } from '@tmt-insights/oms_fe_core/material';
import { TitleConfig } from '@tmt-insights/oms_fe_core';

const titleConfig: TitleConfig = {
  disableTMDB: true,
  disableAllVersionsFilter: true,
  v2: true, // TODO(TMT-6046): this config parameter should be removed when all clients use the V2 titles API.
  fileStatusFilter: ['Available', 'Pending Ingest', 'Hidden', 'Cancelled'],
  metadata: {
    name: {
      label: 'Name',
      entity_type: ['series', 'season', 'episode'],
      render: (_value: any, _title, parentTitle) => parentTitle?.name
    },
    duration: {
      label: 'Duration'
    },
    producer: {
      label: 'Producer',
      render: (value: 'string', _title, parentTitle) => {
        return [value, parentTitle?.producer_2].join(',');
      }
    },
    director: {
      label: 'Director'
    },
    external_id: {
      label: 'External ID'
    }
  },
  renderLabelFn(title) {
    const isSeason = title.entity_type === 'season';
    const isEpisode = title.entity_type === 'episode';
    const isSpecials = isSeason && title.name?.toLowerCase() === 'specials';
    return (
      <>
        {(isSeason || isEpisode) && (
          <Typography variant="subtitle2" sx={{ mr: 1 }}>
            {isSpecials ? 'Specials' : `${title.entity_type.charAt(0).toUpperCase()}${title.sequence_order}:`}
          </Typography>
        )}
        {!isSpecials && title.name}
      </>
    );
  }
};

export default titleConfig;
